//@import dependencies
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import IconComponent from 'app_components/commons/icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import AlertComponent from 'app_components/commons/alert';
import ModalSchedulingFormModule from 'app_components/modules/admin/landings/modalSchedulingForm';
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../schedulingFormModule.scss'

// @ADD Component types
interface ISchedulingFormModuleLayoutProps {
  permission: any
  source: string
  listOfSchedulings: Array<any>
  onHandleSchedulingSubmit: (data: any) => void | null
  onHandleSchedulingRemove: (data: any) => void | null
}

const SchedulingFormModuleLayout: React.FC<ISchedulingFormModuleLayoutProps> = (props) => {

  const [colors] = useColors()

  const [modalSchedulingFormStatus, setModalSchedulingFormStatus] = useState<boolean>(false)

  const [schedulingEditData, setSchedulingEditData] = useState<any>(null)

  const { t } = useTranslation()

  const handleOpenModalScheduling = () => {
    setModalSchedulingFormStatus(true)
  }

  const handleCloseModalScheduling = async (data: any) => {
    setSchedulingEditData(null)
    setModalSchedulingFormStatus(false)
    if (data?.status === true && data?.data) {
      props.onHandleSchedulingSubmit({status: 'success'})
    }
  }

  const editScheduling = (scheduling: number) => {
    setSchedulingEditData(scheduling)
    setModalSchedulingFormStatus(true)
  }

  const removeScheduling = (unique: string) => {
    props.onHandleSchedulingRemove(unique)
  }

  return(
    <div className=''>
      <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">{t("modules.teacher_landing_form.sections.scheduling")}</h3>
      </div>

      <div className="row">
        {props.permission.checkSimple(`permission:landings_${props.source}_scheduling`) && (
          <div className="col-12 text-right mb-3">
            <button className="btn btn-primary" onClick={handleOpenModalScheduling} type="button">
              <IconComponent fontawesome={{icon: 'fa fa-plus'}} />&nbsp;&nbsp;
              {t("modules.teacher_landing_form.scheduling.add")}
            </button>
          </div>
        )}
        {props.listOfSchedulings.length > 0 ? (
          <>
            {props.listOfSchedulings.map((scheduling) => (
              <div className="col-12">
                <div className="scheduling-item">
                  <div className="scheduling-content">
                    <div>
                      <b>{t("modules.teacher_landing_form.scheduling.list.title")}:</b> {scheduling.title}
                    </div>
                    {scheduling.attachedFile && (
                      <div>
                        <b>{t("modules.teacher_landing_form.scheduling.list.attached")}:</b> <a href={scheduling.attachedFile} target="__blank" rel="noopener noreferrer" >Descarga aqui</a>
                      </div>
                    )}
                  </div>
                  <div className="scheduling-actions">
                    {props.permission.checkSimple(`permission:landings_${props.source}_scheduling`) && (
                      <>
                        <OverlayTrigger
                          trigger={['hover', 'focus']}
                          placement={'top'}
                          overlay={
                            <Tooltip id='toolip-circle'>
                              {t("modules.teacher_landing_form.scheduling.edit")}
                            </Tooltip>
                          }>
                            <div className="session-action" onClick={() => editScheduling(scheduling)}>
                              <IconComponent fontawesome={{icon: 'fas fa-edit'}} color={colors.primary} />
                            </div>
                        </OverlayTrigger>
                        &nbsp;&nbsp;
                        <OverlayTrigger
                          trigger={['hover', 'focus']}
                          placement={'top'}
                          overlay={
                            <Tooltip id='toolip-circle'>
                              {t("modules.teacher_landing_form.scheduling.delete")}
                            </Tooltip>
                          }>
                            <div className="session-action" onClick={() => removeScheduling(scheduling.unique)}>
                              <IconComponent fontawesome={{icon: 'fas fa-trash-alt'}} color={colors.primary} />&nbsp;&nbsp;
                            </div>
                        </OverlayTrigger>
                      </>
                    )}
                  </div>

                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="col-12">
            <AlertComponent
              type='warning'
              title={t('modules.teacher_landing_form.scheduling.no_data')}
            />
          </div>
        )}

      </div>
      {modalSchedulingFormStatus && (
        <ModalSchedulingFormModule
          source={props.source}
          open={modalSchedulingFormStatus}
          handleClose={handleCloseModalScheduling}
          editData={schedulingEditData}
        />
      )}
    </div>
  )
}

export default SchedulingFormModuleLayout
